import React from 'react';
import { Translation } from 'react-i18next';
import ResourceModel from './Resource';
import { toSentenceCase } from '../utils/format';
import type { ResourceType } from '../types/resource';
import { createResourceModel } from '../utils/health-resources';

export default class AggregatedResource extends ResourceModel {
  resources: ResourceType[];

  constructor(resources: Array) {
    const properties = {
      resource_type: resources[0] && resources[0].resource_type
    };
    super(properties);
    this.properties = properties;
    this.resources = resources.map((r) => createResourceModel(r));
  }
  get id(): Number {
    return this.resources[0].id;
  }
  get aggregated() {
    return true;
  }
  get title(): String {
    return `${toSentenceCase(this.properties.resource_type)}s`;
  }
  get resource_type(): String { // eslint-disable-line
    return this.resources[0] && this.resources[0].resource_type;
  }
  get type(): String {
    return this.resources[0] && this.resources[0].type;
  }
  get color(): String {
    return this.resources[0] && this.resources[0].color;
  }
  get institution_name(): any { // eslint-disable-line
    const institution_names = [] // eslint-disable-line
    this.resources.forEach((r) => {
      if (r.institution_name && institution_names.indexOf(r.institution_name) === -1) {
        institution_names.push(r.institution_name);
      }
    });
    if (institution_names.length === 0) {
      return (
        <Translation ns='immunization'>
          {(t) => t('my_upload')}
        </Translation>
      );
    }
    return (
      <Translation ns='aggregated'>
        {(t) => t(
          'from_institution',
          {
            institution: institution_names[0],
            count: institution_names.length - 1
          })}
      </Translation>
    );
  }

  get sortingPriority(): Number {
    return 3;
  }

  // get resources(): [] {
  //   return this.resources;
  // }

  get recordedAt(): String {
    return this.resources[0].recordedAt;
  }

  updateValues(props: any) {
    this.properties = {
      ...this.properties,
      ...props
    };
  }
  get generated() {
    return {};
  }
}



// WEBPACK FOOTER //
// ./src/models/Aggregated.js